<template>
  <div class="redirect-container">
    <div class="loading">
      <div class="spinner"></div>
      <p>{{ message }}</p>
    </div>
  </div>
</template>

<script>
import { get } from '@/net/http';

export default {
  name: 'Redirect',
  data() {
    return {
      message: '正在加载报告...'
    };
  },
  async mounted() {
    try {
      const scene = this.$route.query.scene;
      
      if (!scene) {
        this.message = '缺少必要参数';
        console.error('缺少scene参数');
        return;
      }

      // 解析scene参数
      const reportId = this.parseScene(scene);
      
      if (!reportId) {
        this.message = '参数解析失败';
        console.error('无法从scene中解析报告编号');
        return;
      }

      console.log('[Redirect] 报告编号:', reportId);
      this.message = '正在获取报告信息...';

      // 获取报告URL
      const response = await get(`/api/v1/report/url/${reportId}`);
      console.log('[Redirect] 后端返回:', response);
      
      let reportUrl = response?.url || response;

      if (!reportUrl) {
        this.message = '报告地址获取失败';
        console.error('后端未返回URL');
        return;
      }

      // 解码HTML实体
      reportUrl = this.decodeHtmlEntities(reportUrl);
      console.log('[Redirect] 解码后URL:', reportUrl);
      
      // 检查URL是否包含有效参数
      if (reportUrl.includes('packageNo=&') || !reportUrl.includes('packageNo=')) {
        console.warn('[Redirect] 后端返回URL参数为空，使用reportId直接跳转');
        const baseUrl = window.location.origin;
        reportUrl = `${baseUrl}/?packageNo=${reportId}`;
      }
      
      this.message = '正在跳转...';
      console.log('[Redirect] 准备跳转到:', reportUrl);
      
      // 跳转到报告页面
      setTimeout(() => {
        window.location.href = reportUrl;
      }, 300);
      
    } catch (error) {
      console.error('[Redirect] 跳转失败:', error);
      this.message = '加载失败，请稍后重试';
    }
  },
  methods: {
    parseScene(scene) {
      // 解码scene参数
      const decoded = decodeURIComponent(scene);
      console.log('解码后scene:', decoded);
      
      // 如果scene直接是报告编号
      if (!decoded.includes('=')) {
        return decoded;
      }
      
      // 如果scene是键值对格式: serial_number=113222
      const params = {};
      decoded.split('&').forEach(item => {
        const [key, value] = item.split('=');
        params[key] = value;
      });
      
      return params.serial_number || params.sn;
    },
    
    decodeHtmlEntities(text) {
      const textarea = document.createElement('textarea');
      textarea.innerHTML = text;
      return textarea.value;
    }
  }
};
</script>

<style scoped>
.redirect-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: #f5f5f5;
}

.loading {
  text-align: center;
}

.spinner {
  width: 50px;
  height: 50px;
  margin: 0 auto 20px;
  border: 4px solid #e0e0e0;
  border-top-color: #003cbf;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

p {
  font-size: 16px;
  color: #666;
}
</style>
